/* tslint:disable */
/* eslint-disable */
/**
 * Incendium AI API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { ApiAIChunkFromJSON, ApiAIChunkToJSON, } from './ApiAIChunk';
export function ApiReadPromptResultResponseFromJSON(json) {
    return ApiReadPromptResultResponseFromJSONTyped(json, false);
}
export function ApiReadPromptResultResponseFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'chunks': !exists(json, 'chunks') ? undefined : (json['chunks'].map(ApiAIChunkFromJSON)),
    };
}
export function ApiReadPromptResultResponseToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'chunks': value.chunks === undefined ? undefined : (value.chunks.map(ApiAIChunkToJSON)),
    };
}
